import { useContext } from 'react';
import { ToastContext } from './toastContext';
import type { ToastContextValue } from '../types/toastContext';

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);

  if (context === null) {
    throw new Error('useToast must be used within ToastProvider');
  }

  return context;
}
